import { FilterIdsKeys, State } from '../../Providers/Provider'

export const upToTwoFiltersApplied = (keys: (keyof FilterIdsKeys)[], state: State) => {
  return (
    keys.filter((filter) => {
      const value = state[filter]

      if (Array.isArray(value)) {
        return value.length > 0
      }

      if (typeof value === 'object') {
        return Object.values(value ?? {}).some((i) => i.length > 0)
      }

      return false
    }).length >= 2
  )
}
